<div class="widget-container" #nestedwidget>
  <main>
    <article #fs
             fullscreen-able
             [ngClass]="{ 'is-active': isActive, 'fullscreen-padding': isActive }"
             style="background-color: white; overflow: auto;">
      
      <div [style.display]="noData ? 'none' : ''" #heatMapContainer></div>

      <div *ngIf="item && items">
        <div *ngFor="let ab of widgetItems">
          <ng-container *ngIf="ab.key == items.key">
            <ng-container [app-widget]="{ item: items, pageKey: pageKey }"></ng-container>
          </ng-container>
        </div>
      </div>
      
    </article>
  </main>
</div>